import React from "react";
import ResumeTitle from "./ResumeTitle";
import { MdWork } from "react-icons/md";
import { GiGraduateCap } from "react-icons/gi";
import ResumeCard from "./ResumeCard";
const keySkillsDataForSynergix = [
  {
    title: "Testing & Quality Assurance:",
    desc: "Thoroughly test the product Synergix LEDR across multiple platforms, ensuring robust performance and reliability. Develop and execute detailed test plans and scripts for various system environments.",
  },
  {
    title: "Cloud Deployment (Azure):",
    desc: "Involved in deploying projects on Azure Cloud, managing Resource Groups, and configuring cloud resources for smooth application delivery.",
  },
  {
    title: "Virtual Machine Creation & Management:",
    desc: "Expertise in creating and maintaining VMs across various operating systems, including Windows, Linux, Fedora, and RedHat within Hyper-V environments.",
  },
  {
    title: "API Integration:",
    desc: "Experience in Open API data fetching, enabling seamless communication between different systems.",
  },
  {
    title: "SQL & Database Management:",
    desc: "Set up SQL SA passwords and manage backend systems for secure and effective database operations.",
  },
  {
    title: "Azure Monitoring & Log Analysis: ",
    desc: "Use KQL queries to analyze Sysmon events and Azure logs, enhancing system monitoring and threat detection.",
  },
];
const keySkillsDataForJR = [
  {
    title: "Frontend Development:",
    desc: "Worked with technologies like HTML, CSS, and JavaScript to build responsive and dynamic user interfaces, ensuring optimal performance across different devices.",
  },
  {
    title: "Backend Development:",
    desc: "Assisted in developing server-side logic using Node.js and Express.js, integrating APIs, and managing databases using MySQL and MongoDB for data storage.",
  },
  {
    title: "API Integration:",
    desc: "Participated in integrating third-party APIs to enable data fetching and improve the functionality of web applications.",
  },
  {
    title: "Version Control:",
    desc: "Collaborated with the development team using Git and GitHub to manage code versions and work on shared repositories effectively.",
  },
  {
    title: "Debugging & Troubleshooting:",
    desc: "Identified and resolved bugs and performance issues to improve the efficiency and user experience of applications.",
  },
];

const keySkillsDataForNxtWave = [
  {
    title: "Frontend Development:",
    desc: "Gained proficiency in HTML, CSS, JavaScript, and frameworks like React, focusing on building responsive and dynamic web interfaces.",
  },
  {
    title: "Backend Development:",
    desc: "Developed server-side applications using Node.js, Express.js, and databases such as MongoDB and MySQL for efficient data management.",
  },
  {
    title: "API Integration:",
    desc: "Worked on integrating RESTful APIs to enhance web application functionality.",
  },
  {
    title: "Version Control:",
    desc: "Experienced in using Git for collaborative development and version management.",
  },
  {
    title: "Agile Methodology:",
    desc: "Participated in Agile processes, contributing to sprint planning, task management, and continuous project improvements.",
  },
];

const Education = () => {
  return (
    <div className="w-full grid grid-cols-9 px-6">
      <div className="col-span-9 md:col-span-4">
        <ResumeTitle title="Experience" icon={<MdWork />} />
        <ResumeCard
          badge=""
          title="Softwarew QA Analyst"
          subTitle="Synergix LABS"
          des="As a Software QA Analyst at Synergix Labs, based in New Jersey, I specialize in ensuring the quality and performance of various software solutions, with a particular focus on cloud deployment and virtual environments. My role spans a range of responsibilities in testing, deployment, and backend systems."
          keypoints={keySkillsDataForSynergix}
          mainHeading=""
        />
        <ResumeCard
          badge="Jun 2023 - Dec 2023"
          title="Full Stack Developer Intern"
          subTitle="JOHN RAICKER IT SERVICES PRIVATE LIMITED"
          des="As a Full Stack Developer Intern at John Raicker IT Services Private Limited, I contributed to the design, development, and deployment of web applications, gaining hands-on experience with both frontend and backend technologies. I collaborated with senior developers and team members to deliver scalable and user-friendly solutions."
          keypoints={keySkillsDataForJR}
          mainHeading=""
        />
      </div>
      <div className="w-full h-full hidden lgl:flex justify-center items-center">
        <span className="w-[1px] h-full bg-zinc-800 inline-flex"></span>
      </div>
      <div className="col-span-9 md:col-span-4">
        <ResumeTitle title="Education" icon={<GiGraduateCap />} />
        <ResumeCard
          badge="Sep 2022 - June 2023"
          title="Nxtwave Disruptive Technologies"
          subTitle="Hyderabad"
          des="I am currently completing a comprehensive Full-Stack Development course at Nxtwave Disruptive Technologies, Hyderabad. This program has equipped me with practical, hands-on experience in both frontend and backend development, with the final exams pending."
          keypoints={keySkillsDataForNxtWave}
          mainHeading="Key Skills Acquired:"
        />
        <ResumeCard
          badge="2019 - 2022"
          title="MKR Government Degree College, DEVARAKONDA"
          subTitle="B.com Computer Applications (72.0%)"
          des="I successfully completed my Bachelor of Commerce in Computer Applications with an overall score of 72%. This degree equipped me with a strong foundation in business principles, accounting, and computer applications, providing essential skills in programming, database management, and financial analysis. Throughout my coursework, I gained hands-on experience in various programming languages, databases, and business applications, which laid the groundwork for my technical and analytical capabilities."
          keypoints=""
          mainHeading=""
        />
        <ResumeCard
          badge="2017-2019"
          title="GOVERNMENT JUNIOR COLLEGE, HALIYA"
          subTitle="Intermediate MPC (63.0%)"
          des="I completed my Intermediate with a focus on Mathematics, Physics, and Chemistry (MPC) at Government Junior College, Haliya, achieving an overall percentage of 63%. This course laid the foundation for my analytical and problem-solving skills, providing a solid understanding of core scientific principles and mathematical concepts, which are essential for various technical and engineering fields."
          keypoints=""
          mainHeading=""
        />
        <ResumeCard
          badge="2016-2017"
          title="ZPHS HALIYA, NALGONDA"
          subTitle="Secondary School Of Certificate (83.0%)"
          des="I completed my Secondary School Certificate (SSC) at ZPHS Haliya, Nalgonda, with a CGPA of 8.3. My education during this time provided a strong foundation in a wide range of subjects, including mathematics, science, and languages, fostering a well-rounded academic background and preparing me for higher education."
          keypoints=""
          mainHeading=""
        />
      </div>
    </div>
  );
};

export default Education;
